/**
 * App router. HR Login (/login) and Admin Login (/admin/login).
 * ProtectedRoute: no token → redirect to login (or admin/login for admin routes).
 */
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import AdminLogin from './AdminLogin';
import DeepLinkApprove from './DeepLinkApprove';
import ManagerDashboard from './ManagerDashboard';
import EmployeeDashboard from './EmployeeDashboard';
import AdminDashboard from './AdminDashboard';

function ProtectedRoute({ children, redirectTo = '/login' }) {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}

const routerFuture = { v7_startTransition: true, v7_relativeSplatPath: true };

function App() {
  return (
    <BrowserRouter future={routerFuture}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/deep-link/:token" element={<DeepLinkApprove />} />
        <Route
          path="/manager"
          element={
            <ProtectedRoute>
              <ManagerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee"
          element={
            <ProtectedRoute>
              <EmployeeDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute redirectTo="/admin/login">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export { ProtectedRoute };
export default App;
